import { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './DropDownServices.module.css';

function DropDownServices({ isOpen, setIsOpen }) {
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [setIsOpen]);

    return (
        <div className={styles.dropdownContainer} ref={dropdownRef}>
            <span 
                className={`${styles.servicos} ${isOpen ? styles.active : ''} ${styles.triggerSpan}`} 
                onClick={() => setIsOpen(!isOpen)}
            >Serviços<span className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`}>▼</span>
            </span>

            {isOpen && (
                <div className={styles.dropdownMenu}>
                    <Link to="/servico/gestao-contabil" onClick={() => setIsOpen(false)}>Gestão Contábil</Link>
                    <Link to="/servico/gestao-de-empresas" onClick={() => setIsOpen(false)}>Gestão de Empresas</Link>
                    <Link to="/servico/gestao-trabalhista-rh" onClick={() => setIsOpen(false)}>Gestão Trabalhista & RH</Link>
                    <Link to="/servico/planejamento-tributario" onClick={() => setIsOpen(false)}>Planejamento Tributário</Link>
                    <Link to="/servico/imposto-de-renda" onClick={() => setIsOpen(false)}>Imposto de Renda</Link>
                    <Link to="/servico/servicos-complementares" onClick={() => setIsOpen(false)}>Serviços Complementares</Link>
                </div>
            )}
        </div>
    );
}

export default DropDownServices;